import React from 'react'
import { IconProps } from '.'

export const AppleSpinnerIcon = (props: IconProps) => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        color="#0075C9"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6 0.875C6.34517 0.875 6.625 1.15482 6.625 1.5V3C6.625 3.34518 6.34517 3.625 6 3.625C5.65483 3.625 5.375 3.34518 5.375 3V1.5C5.375 1.15482 5.65483 0.875 6 0.875Z"
            fill="currentcolor"
            stroke="currentcolor"
            strokeWidth="0.125"
        />
        <path
            d="M10.5 5.375C10.8452 5.375 11.125 5.65483 11.125 6C11.125 6.34517 10.8452 6.625 10.5 6.625H9C8.65483 6.625 8.375 6.34517 8.375 6C8.375 5.65483 8.65483 5.375 9 5.375H10.5Z"
            fill="currentcolor"
            stroke="currentcolor"
            strokeWidth="0.125"
        />
        <path
            d="M7.68066 7.68115C7.92475 7.43711 8.32135 7.43711 8.56543 7.68115L9.62402 8.74072C9.86806 8.9848 9.86806 9.38043 9.62402 9.62451C9.37994 9.86855 8.98432 9.86855 8.74023 9.62451L7.68066 8.56592C7.43662 8.32184 7.43662 7.92523 7.68066 7.68115Z"
            fill="currentcolor"
            stroke="currentcolor"
            strokeWidth="0.125"
        />
        <path
            d="M6 8.375C6.34517 8.375 6.625 8.65483 6.625 9V10.5C6.625 10.8452 6.34517 11.125 6 11.125C5.65483 11.125 5.375 10.8452 5.375 10.5V9C5.375 8.65483 5.65483 8.375 6 8.375Z"
            fill="currentcolor"
            stroke="currentcolor"
            strokeWidth="0.125"
        />
        <path
            d="M3.43457 7.68115C3.67853 7.43732 4.07427 7.43752 4.31836 7.68115C4.5624 7.92523 4.5624 8.32184 4.31836 8.56592L3.25977 9.62451C3.01569 9.86855 2.61908 9.86855 2.375 9.62451C2.13135 9.38043 2.13116 8.98468 2.375 8.74072L3.43457 7.68115Z"
            fill="currentcolor"
            stroke="currentcolor"
            strokeWidth="0.125"
        />
        <path
            d="M3 5.375C3.34518 5.375 3.625 5.65483 3.625 6C3.625 6.34517 3.34518 6.625 3 6.625H1.5C1.15482 6.625 0.875 6.34517 0.875 6C0.875 5.65483 1.15482 5.375 1.5 5.375H3Z"
            fill="currentcolor"
            stroke="currentcolor"
            strokeWidth="0.125"
        />
        <path
            d="M2.375 2.37476C2.61908 2.13068 3.01569 2.13068 3.25977 2.37476L4.31836 3.43433C4.5624 3.6784 4.5624 4.07403 4.31836 4.31812C4.07428 4.56216 3.67865 4.56216 3.43457 4.31812L2.375 3.25952C2.13092 3.01544 2.13092 2.61883 2.375 2.37476Z"
            fill="currentcolor"
            stroke="currentcolor"
            strokeWidth="0.125"
        />
    </svg>
)
